import React, { useState, useEffect } from 'react';

const AnimatedTitle = ({text}) => {
    const words = ['Barcelona', 'New York', 'Paris', 'Tokyo', 'Sydney', 'London', 'Bangkok', 'Berlin', 'Rome', 'Dubai', 'Istanbul', 'Cape Town', 'Rio de Janeiro', 'Los Angeles', 'Amsterdam', 'Budapest', 'Prague', 'Vienna', 'Lisbon', 'Madrid', 'Athens', 'Moscow', 'Stockholm', 'Dublin'];
    const [currentWordIndex, setCurrentWordIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
        }, 4000);

        return () => clearInterval(interval);
    }, [words.length]);

    return (
        <>
            <style>
                {`
    .animated-title {
      position: relative;
      display: inline-block;
    }

    .animated-word {
      display: inline-block;
      animation: fadeInOut 4s infinite;
    }

    @keyframes fadeInOut {
      0% {
        opacity: 0;
      }
      25% {
        opacity: 1;
      }
      75% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  `}
            </style>
            <h2 className="font-semibold text-6xl text-secondary animated-title w-full">
                {text}
                <br />
                <span className="animated-word font-bold text-8xl">{words[currentWordIndex]}</span>
            </h2>
        </>
    );
};

export default AnimatedTitle;